module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/thanks-60.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/about/thanks.md
// module id = 632
// module chunks = 398